import { Outlet } from "react-router-dom";
import "./layout.css";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

/** Persistent chrome: left sidebar + top bar around the routed page. */
export function AppShell() {
  return (
    <div className="shell">
      <Sidebar />
      <Topbar />
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
